<template>
  <v-app>
    <header class="mb-4">
      <v-card id="navbar" color="light-blue darken-4" class="py-3"
      flat>
        <v-container>
          <v-row justify="center">
            <v-col cols="12" sm="12" md="11" lg="11" xl="11">
              <v-card color="light-blue darken-4" class="d-flex justify-start align-center"
              >
                <v-card class="d-none d-md-flex" color="light-blue darken-4">
                  <v-img contain src="./assets/smads.png" max-width="128px"></v-img>
                </v-card>
                <v-card color="pl-8 light-blue darken-4">
                  <div class="d-flex align-center flex-column">
                    <h1 class="white--text">CENTRAL DE VAGAS</h1>
                    <p class="white--text mx-0 my-0">Formulário de Solicitação de Vagas</p>
                  </div>
                </v-card>
                <v-card color="light-blue darken-4 ml-auto">
                  <Header /> 
                </v-card>
              </v-card>
            </v-col>
          </v-row>
          <v-row justify="center" v-show="!isLoginPage">
            <v-col cols="12" sm="12" md="11" lg="11" xl="11" class="pt-4" style="border-top: #0277bd 1px solid">
              <v-card
                color="light-blue darken-4"
              >
                  <v-row
                    align="center"
                  >
                    <v-btn
                      color="primary"
                      class="font-weight-regular"
                      tile
                      elevation="0"
                      v-if="isAuthenticated" to="/ListRequest"
                    ><v-icon>mdi-archive-edit</v-icon>Solicitações</v-btn>
                  </v-row>
              </v-card> 
            </v-col>
        </v-row>
        </v-container>
      </v-card>    
    </header>    
    
    <Content/>    
    <Footer />
    <ConfirmDialog ref="confirm" />
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";

import Content from "./components/Content";
import Footer from "./components/Footer";
import Header from "./components/Header";
import {initSession} from "./plugins/session-manager";
import ConfirmDialog from './components/ConfirmDialog';

export default {
  name: 'App',
  components: {
    Header,
    Footer,
    Content,
    ConfirmDialog,
  },
  computed: {
    ...mapGetters('login', ['isAuthenticated','isLoginPage']),
  },
  data: () => ({
    //
  }),
  mounted(){
    initSession();
    this.$root.$confirm = this.$refs.confirm;
  },
};
</script>
<style scoped>

.v-application--wrap > .v-card {
  box-shadow: none !important;
  border-radius: 0 !important;
}
.v-sheet.v-card {
  box-shadow: none !important;
  border-radius: 0;
}
.v-card .v-toolbar {
  
}
h1 {
  font-size: 1.8rem;
  line-height: 1.8rem;
}

@media print {
  header{display: none !important; }
  .go-back, button, .v-icon.v-icon {display: none !important;}
  footer {display: none !important; }
}

</style>